import { render, staticRenderFns } from "./form-side.vue?vue&type=template&id=257e2a27&scoped=true&"
import script from "./form-side.vue?vue&type=script&lang=js&"
export * from "./form-side.vue?vue&type=script&lang=js&"
import style0 from "./form-side.vue?vue&type=style&index=0&id=257e2a27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e2a27",
  null
  
)

export default component.exports